<template>
  <Layout>
    <PageHeader :title="title" :items="items" />

    <div class="row" v-if="userData.permissions['view_dashboard']==1">
      <div class="col-12">
        <div class="card">
          <div class="card-body">
            <div class="mb-2 float-end">
              <b-button v-show="userData.permissions['view_dashboard']==1" v-b-modal.new-category size="sm" variant="primary"><i class="mdi mdi-plus"></i> New Donation</b-button>
            </div>
            <div class="clearfix"></div>
            <div class="row">
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_length" class="dataTables_length">
                  <label class="d-inline-flex align-items-center">
                    Show <b-form-select class="form-select form-select-sm mx-1" v-model="perPage" size="sm" :options="Options"></b-form-select> entries
                  </label>
                </div>
              </div>
              <div class="col-sm-12 col-md-6">
                <div id="tickets-table_filter" class="dataTables_filter text-md-end" >
                  <label class="d-inline-flex align-items-center">
                    Search: <b-form-input v-model="filter" type="search" placeholder="Search..." class="form-control form-control-sm ms-2"></b-form-input>
                  </label>
                </div>
              </div>
            </div>
            <div class="table-responsive">
              <b-table
                :items="Items"
                :fields="Fields"
                responsive="sm"
                :per-page="perPage"
                :current-page="currentPage"
                :filter="filter"
                :filter-included-fields="filterOn"
                @filtered="Filtered"
                :busy="IsBusy"
              >
              <template #table-busy>
                  <div class="text-center text-primary my-2"><b-spinner v-if="isBusy" class="align-middle" type="grow"
                      small></b-spinner> <i v-else class="fs-5 mdi mdi-cancel"></i> <strong>{{ isBusy ? 'Fetching Data...' : 'No Data Found' }}</strong></div>
                </template>              <template #cell(index)="data">
                {{ data.index + 1 }}
              </template>
              <template #cell(addedby)="data">
                {{ data.item.addedby }}
              </template>
              <template #cell(actions)="data">
                <div class="btn-group">
                <b-button @click="edit(data.item.id,data.item.name,data.item.amount,data.item.donationfrom,data.item.description,data.item.donationdate )" type="button" class="btn-sm btn" variant="primary" v-b-modal.edit> <i class="mdi mdi-square-edit-outline"></i> </b-button>
                <b-button @click="remove(data.item.id,data.item.name)" type="button" class="btn-sm btn" variant="danger"  v-b-modal.delete> <i class="mdi mdi-trash-can"></i> </b-button>
                </div>
              </template>
              </b-table>
            </div>
            <div class="row">
              <div class="col">
                <div class="dataTables_paginate paging_simple_numbers float-end">
                  <ul class="pagination pagination-rounded mb-0">
                    <b-pagination v-model="currentPage" :total-rows="List" :per-page="perPage"></b-pagination>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div v-else>
      <div class="row justify-content-center">
        <div class="col-md-8 col-xl-6">
          <div>
            <img src="@/assets/images/profile-img.png" alt class="img-fluid" /><br><br>
            <center><span class="text-primary h6">You have no permission to View Donations</span></center>
          </div>
        </div>
      </div>
    </div>

    <b-modal id="new-category" centered title="New Donation" title-class="font-18" hide-footer>
        <form @submit.prevent="addDonation">
            <div class="form-group mb-2">
            <label>Donation Name</label>
            <input v-model="name" type="text" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Donation Amount</label>
            <input v-model="amount" type="number" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>From</label>
            <input v-model="donationfrom" type="text" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Description</label>
            <textarea v-model="description" class="form-control" rows="3"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Donation Date</label>
            <input v-model="donationdate" type="date" class="form-control" />
            </div>         

            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('new-category')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="edit-category" centered title="Edit Donation" title-class="font-14" hide-footer>
        <form @submit.prevent="editDonation">
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Donation Name</label>
            <input v-model="name" type="text" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <input v-model="id" type="hidden">
            <label>Donation Amount</label>
            <input v-model="amount" type="number" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>From</label>
            <input v-model="donationfrom" type="text" class="form-control" />
            </div>
            <div class="form-group mb-2">
            <label>Description</label>
            <textarea v-model="description" class="form-control" rows="3"></textarea>
            </div>
            <div class="form-group mb-2">
            <label>Donation Date</label>
            <input v-model="donationdate" type="date" class="form-control" />
            </div>    
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('edit-category')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> Submit</b-button>
            </div>
        </form>
    </b-modal>

    <b-modal id="delete-category" centered title="Delete Donation" title-class="font-18" hide-footer>
        <form @submit.prevent="removeDonation">
            <input v-model="id" type="hidden">
              Are you sure you want to delete the Donation : <b>{{ name }}</b> ?
            <div class="form-group d-flex justify-content-end">
                <b-button type="button" class="btn w-30" variant="secondary" @click="$bvModal.hide('delete-category')" >Close</b-button>
                <b-button type="submit" class="btn ms-1 w-30" variant="primary" ><i class="fas fa-check-circle"></i> YES</b-button>
            </div>
        </form>
    </b-modal>

  </Layout>
</template>

<script>
import axios from "axios";
import Layout from "../../layouts/main";
import PageHeader from "@/components/page-header";
import appConfig from "@/app.config";
import { donationMethods, donationComputed } from "@/state/helpers";

export default {
  page: {
    title: "Donations",
    meta: [{ name: "description", content: appConfig.description,},],
  },
  components: {
    Layout,PageHeader
  },
  data() {
    return {
      userData: JSON.parse(localStorage.getItem("user")),
      title: "Donations",
      items: [ {text: "Dashboard",to: "/",}, {text: "Donations",active: true, }, ],
      TotalRows: 1,
      currentPage: 1,
      perPage: 10,
      Options: [10, 50, 100, 150, 200],
      filter: null,
      todoFilter: null,
      filterOn: [],
      sortDesc: true,
      isBusy: true,
      fields: [
          { key: 'index', label: '#', visible: true },
          { key: 'id', label: 'ID', visible: false },
          { key: 'name', label: 'Name', visible: true },
          { key: 'amount', label: 'Amount', visible: true },
          { key: 'donationfrom', label: 'From', visible: true },
          { key: 'description', label: 'Description', visible: true },
          { key: 'donationdate', label: 'Donation Date', visible: true },
          { key: 'addedby', label: 'Added by', visible: true },
          { key: 'actions', label: 'Actions', visible: true },
        ],
      id:'',
      name:'',
      amount: '',
      donationfrom: '',
      description: '',
      donationdate: '',
    };
  },
  computed: {
    ...donationComputed,
    List() { return this.donations.length; },
    Fields() { return this.fields.filter(field => field.visible) },
    Items() { return this.donations.map((d) => ({...d }))},
    IsBusy() { let a=false; if (this.donations.length>0) { a=false;} else { a=true;} return a },
  },
  async mounted() {
    await this.fetchDonations();
    this.TotalRows = this.donations.length;
    this.isBusy=false;
  },
  methods: {
    ...donationMethods,
    Filtered(filteredItems) {
      this.TotalRows = filteredItems.length;
      this.currentPage = 1;
    },
    edit(id,name,amount,donationfrom,description,donationdate){
      this.id=id;
      this.name=name;
      this.amount=amount;
      this.donationfrom=donationfrom;
      this.description=description;
      this.donationdate=donationdate;
      this.$bvModal.show('edit-category')
    },
    remove(id,name){
      this.id=id;
      this.name=name;
      this.$bvModal.show('delete-category')
    },
    async addDonation() { 
      let formData = new FormData();
      formData.append("name", this.name);
      formData.append("amount", this.amount);
      formData.append("donationfrom", this.donationfrom);
      formData.append("description", this.description);
      formData.append("donationdate", this.donationdate);
      let url = "/adddonation";
      await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
          this.fetchDonations();
          this.$bvModal.hide('new-category');
          this.name="";
      }
      });
    },
    async editDonation(){ 
    let formData = new FormData();
    formData.append("id", this.id);
    formData.append("name", this.name);
    formData.append("amount", this.amount);
    formData.append("donationfrom", this.donationfrom);
    formData.append("description", this.description);
    formData.append("donationdate", this.donationdate);
    let url = "/updatedonation";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchDonations();
        this.$bvModal.hide('edit-category');
        this.name="";
      }
    });
    },
    async removeDonation() { 
    let formData = new FormData();
    formData.append("id", this.id);
    let url = "/removedonation";
    await axios.post(url, formData).then((response) => {
      if (response.status == 200) {
        this.fetchDonations();
        this.$bvModal.hide('delete-category');
      }
    });
    },
  },
};
</script>